import React, { Fragment, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import sainDurAjiluud from "../../api/saindur";
import Header from "../../components/header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Mcc from "../../components/mcc/Mcc";

const SainDurPage = ({ isDark, onToggleDark }) => {
  const [activeFilter, setActiveFilter] = useState("buh");

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  const filteredDonation =
    activeFilter === "buh"
      ? sainDurAjiluud.slice()
      : sainDurAjiluud
          .slice()
          .filter((sainDurAjiluud) => sainDurAjiluud.category === activeFilter);

  const [activeIndex, setActiveIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setActiveIndex(index);
  };

  return (
    <Fragment>
      <motion.div
        intial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Header isDark={isDark} hclass={"header--styleFour"} />
        <main className="main">
          <PageTitle
            pageTitle={"Хүмүүнлэгийн сайн дурын үйл ажиллагаа"}
            pagesub={"Сайн дур"}
            tolink={"#saind"}
          />
          <div className="about position-relative pt-70 pb-40">
            <Mcc />
            <div className="container">
              <div className="row">
                {/* <div className="col-12">
                  <div className="sectionTitle text-center mb-70" id="saind">
                    <span className="sectionTitle__small justify-content-center">
                      <i className="fa-solid fa-heart btn__icon"></i>
                      МСС
                    </span>
                    <h2 className="sectionTitle__big">
                      Бидний нийгэмд үйлчилсэн сайн дурын үйл ажиллагаанууд
                    </h2>
                  </div>
                </div> */}
              </div>
              <div className="row">
                <div className="col-12">
                  <div id="saind" className="featureTab  featureTab--style2">
                    <ul className="unordered_list">
                      <li
                        className={activeFilter === "buh" ? "active" : ""}
                        onClick={() => handleFilterClick("buh")}
                      >
                        Бүгд
                      </li>
                      <li
                        className={activeFilter === "niigem" ? "active" : ""}
                        onClick={() => handleFilterClick("niigem")}
                      >
                        Нийгэм
                      </li>
                      <li
                        className={activeFilter === "bolov" ? "active" : ""}
                        onClick={() => handleFilterClick("bolov")}
                      >
                        Боловсрол
                      </li>
                      <li
                        className={activeFilter === "medic" ? "active" : ""}
                        onClick={() => handleFilterClick("medic")}
                      >
                        Эрүүл мэнд
                      </li>
                    </ul>
                    <div className="filter_elements_wrapper row gx-3">
                      {filteredDonation
                        .map((donation, index) => (
                          <div className="col-lg-4 col-sm-6 mb-35" key={index}>
                            <div
                              className={`featureBlock ${
                                activeIndex === index
                                  ? "featureBlock--active"
                                  : ""
                              }`}
                              onMouseEnter={() => handleMouseEnter(index)}
                            >
                              <div className="featureBlock__wrap">
                                <figure className="featureBlock__thumb">
                                  <Link
                                    onClick={ClickHandler}
                                    to={`/sain-dur/${donation.slug}`}
                                    className="featureBlock__thumb__link"
                                  >
                                    <img src={donation.sImg} alt="saindurBg" />
                                  </Link>
                                  <Link
                                    onClick={ClickHandler}
                                    to={`/sain-dur/${donation.slug}`}
                                    className="featureBlock__hashLink"
                                  >
                                    <span className="featureBlock__hashLink__text">
                                      {donation.thumb}
                                    </span>
                                  </Link>
                                </figure>
                                <div className="featureBlock__content">
                                  <h3 className="featureBlock__heading">
                                    <Link
                                      onClick={ClickHandler}
                                      to={`/sain-dur/${donation.slug}`}
                                      className="featureBlock__heading__link"
                                    >
                                      {donation.title.slice(0, 20) + "......"}
                                    </Link>
                                  </h3>
                                  {/* <p className="featureBlock__text">
                                We help local nonprofits access the funding,
                                training, and support they need to become more
                              </p> */}
                                </div>
                              </div>
                              {/* <div className="featureBlock__donation">
                            <div className="featureBlock__donation__progress">
                              <div className="featureBlock__donation__bar">
                                <span
                                  className="featureBlock__donation__text skill-bar"
                                  style={{ width: donation.progress }}
                                >
                                  {donation.progress}
                                </span>
                                <div className="featureBlock__donation__line">
                                  <span className="skill-bars">
                                    <span
                                      className="skill-bars__line skill-bar"
                                      style={{ width: donation.progress }}
                                    ></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="featureBlock__eqn">
                              <div className="featureBlock__eqn__block">
                                <span className="featureBlock__eqn__title">
                                  our goal
                                </span>
                                <span className="featureBlock__eqn__price">
                                  {donation.goal}
                                </span>
                              </div>
                              <div className="featureBlock__eqn__block">
                                <span className="featureBlock__eqn__title">
                                  Raised
                                </span>
                                <span className="featureBlock__eqn__price">
                                  {donation.raised}
                                </span>
                              </div>
                              <div className="featureBlock__eqn__block">
                                <span className="featureBlock__eqn__title">
                                  to go
                                </span>
                                <span className="featureBlock__eqn__price">
                                  {donation.togo}
                                </span>
                              </div>
                            </div>
                          </div> */}
                            </div>
                          </div>
                        ))
                        .reverse()}

                      {/* <div className="col-12">
                      <div className="sectionButton text-center pt-15">
                        <Link
                          onClick={ClickHandler}
                          className="btn btn--styleOne btn--primary it-btn"
                          to="/volunteers"
                        >
                          <span className="btn__text">see all Volunteers</span>
                          <i className="fa-solid fa-heart btn__icon"></i>
                          <span className="it-btn__inner">
                            <span className="it-btn__blobs">
                              <span className="it-btn__blob"></span>
                              <span className="it-btn__blob"></span>
                              <span className="it-btn__blob"></span>
                              <span className="it-btn__blob"></span>
                            </span>
                          </span>
                          <svg
                            className="it-btn__animation"
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                          >
                            <defs>
                              <filter>
                                <feGaussianBlur
                                  in="SourceGraphic"
                                  result="blur"
                                  stdDeviation="10"
                                ></feGaussianBlur>
                                <feColorMatrix
                                  in="blur"
                                  mode="matrix"
                                  values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 21 -7"
                                  result="goo"
                                ></feColorMatrix>
                                <feBlend
                                  in2="goo"
                                  in="SourceGraphic"
                                  result="mix"
                                ></feBlend>
                              </filter>
                            </defs>
                          </svg>
                        </Link>
                      </div>
                    </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <Mcc />
            </div>
          </div>
        </main>
        <Footer isDark={isDark} onToggleDark={onToggleDark} />
        <Scrollbar />
      </motion.div>
    </Fragment>
  );
};

export default SainDurPage;
